import produce from "immer";
import { CustomizationState, EditedText } from "../../";

export interface SetEditedTextAction {
  editedText: EditedText | null;
  type: "setEditedText";
}

export function setEditedText(
  state: CustomizationState,
  action: SetEditedTextAction
): CustomizationState {
  return produce(state, (draftState) => {
    if (action.editedText) {
      draftState.ui.editedText = action.editedText;
    } else {
      draftState.ui.editedText = undefined;
    }
  });
}
